import GestionContable from "./GestionContable";

export default GestionContable;
